<template>
  <form ref="form" action="./" method="post">
    <input type="hidden" name="_token" :value="csrfToken" />
    <input type="hidden" name="test_type" :value="abtest.abtest_type" />
    <div class="l-page l-page--abtest-edit">
      <main class="l-main">
        <!-- パンくずリスト -->
        <breadcrumb :breadcrumb-data="breadcrumbData" />
        <!-- /パンくずリスト -->

        <div class="l-main-head">
          <div class="c-title u-w420">
            <h2 class="c-title__text c-title__text--blue u-fs34">
              配信済みA/Bテストの確認
            </h2>
          </div>
        </div>
        <div class="l-main-content">
          <abtest-info :abtest="abtest" />
        </div>
        <div class="l-main-content">
          <div class="p-abtest-edit-preview">
            <div class="p-abtest-edit-preview-list">
              <div class="p-abtest-edit-preview-list__item">
                <h4
                  class="c-title c-title--pattern"
                  data-text="A"
                >
                  <div class="c-title__text u-fs28">
                    Aパターンの配信内容
                  </div>
                </h4>
                <div class="p-message-preview">
                  <div
                    class="c-title c-title--left u-text-white-1"
                  >
                    <div class="c-title__text u-fs--l">
                      プレビュー
                    </div>
                    <div class="c-text u-fs10">
                      実際の配信メッセージと表示が異なることがあります
                    </div>
                  </div>
                  <div class="p-message-preview-list">
                    <message-preview
                      :title="messageA.message_title"
                      :text="messageA.message_text"
                      :url="messageA.click_url"
                      :icon-url="messageA.image_url"
                      :large-image-url="
                        messageA.large_image_url
                      "
                      :has-button-a="
                        messageA.action_button_text_a !=
                          null
                      "
                      :has-button-b="
                        messageA.action_button_text_b !=
                          null
                      "
                      :action-button-text-a="
                        messageA.action_button_text_a
                      "
                      :action-button-text-b="
                        messageA.action_button_text_b
                      "
                    />
                  </div>
                </div>
              </div>
              <div class="p-abtest-edit-preview-list__item">
                <h4
                  class="c-title c-title--pattern"
                  data-text="B"
                >
                  <div class="c-title__text u-fs28">
                    Bパターンの配信内容
                  </div>
                </h4>
                <div class="p-message-preview">
                  <div
                    class="c-title c-title--left u-text-white-1"
                  >
                    <div class="c-title__text u-fs--l">
                      プレビュー
                    </div>
                    <div class="c-text u-fs10">
                      実際の配信メッセージと表示が異なることがあります
                    </div>
                  </div>
                  <div class="p-message-preview-list">
                    <message-preview
                      :title="messageB.message_title"
                      :text="messageB.message_text"
                      :url="messageB.click_url"
                      :icon-url="messageB.image_url"
                      :large-image-url="
                        messageB.large_image_url
                      "
                      :has-button-a="
                        messageB.action_button_text_a !=
                          null
                      "
                      :has-button-b="
                        messageB.action_button_text_b !=
                          null
                      "
                      :action-button-text-a="
                        messageB.action_button_text_a
                      "
                      :action-button-text-b="
                        messageB.action_button_text_b
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="l-main-content">
          <message-action :message="messageA" />
        </div>
      </main>
    </div>
    <div class="p-message-predict p-message-predict--no-number">
      <div class="p-message-predict__content">
        <div class="p-message-predict-suspend"></div>
        <div class="p-message-predict__btns">
          <button
            class="c-btn c-btn--gray u-w320 u-h50 u-fs20"
            type="button"
            name="prev"
            value="prev"
            @click="onBackClick()"
          >
            <p class="c-btn__text">配信メッセージの一覧に戻る</p>
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    csrfToken: String,
    breadcrumbData: Array,
    abtest: Object,
  },
  data() {
    return {};
  },
  computed: {
    messageA: function () {
      let message = null;
      if (this.abtest && this.abtest.abtest_messages.length > 0) {
        message = this.abtest.abtest_messages[0].message;
      }
      return message;
    },
    messageB: function () {
      let message = null;
      if (this.abtest && this.abtest.abtest_messages.length > 1) {
        message = this.abtest.abtest_messages[1].message;
      }
      return message;
    },
  },
  mounted: function () {
    import('../../funcs/pages/abtest-message-add-condition-confirm').then(
      (module) => {
        module.AbtestMessageAddConditionConfirm();
      }
    );
    import('../../funcs/components/select').then((module) => {
      module.Select();
    });
  },
  methods: {
    onBackClick: function () {
      location.href = '/coins-admin/message';
    },
  },
};
</script>
